export default "//static.tradera.net/touchweb/static/output/images/category-childrens-items.9455a7a2.svg";